export default __webpack_public_path__ + "static/media/open-sea-icon.e05664df.svg";